import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import {PrismicRichText} from '@prismicio/react'
import type {PricingSectionSliceLarge} from 'prismicio-types'
import {CTASectionLarge} from 'slices/PricingSection/components/CTASectionLarge'
import {LargePackageSection} from 'slices/PricingSection/components/LargePackageSection'
import {MossPlatformLargeSection} from 'slices/PricingSection/components/MossPlatformLargeSection'
import {Container} from 'src/common/Container'

type PricingSectionLargeProps = {
  slice: PricingSectionSliceLarge & {
    slice_type: string
    variation: string
  }
  componentIndex: number
  pageUid: string
}

export const PricingSectionLarge = ({slice, componentIndex, pageUid}: PricingSectionLargeProps) => (
  <Container
    data-slice-type={slice.slice_type}
    data-slice-variation={slice.variation}
    className="!py-10 md:!py-16"
    data-nav-dark="true"
    backgroundColor="Grey/100"
  >
    <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-10 px-5 md:gap-16 md:px-10 lg:px-5 xl:px-0">
      <div className="flex flex-col gap-16 md:gap-20">
        <div className="flex flex-col gap-6 md:gap-8">
          <div className="flex flex-col gap-4">
            <h3 className="text-center text-[32px] font-medium leading-[34px] tracking-[-.32px] text-moss-black">
              {slice.primary.title}
            </h3>
            <div>
              <PrismicRichText
                field={slice.primary.subtext}
                components={{
                  paragraph: ({children}) => (
                    <p className="text-tg-body-l mx-auto max-w-[513px] text-center text-moss-grey-550">{children}</p>
                  ),
                }}
              />
            </div>
          </div>
          {isFilled.group(slice.primary.top_asset_section) && (
            <div className="mx-auto flex flex-col items-center gap-6 md:gap-8">
              <span className="text-button text-moss-black">{slice.primary.top_asset_section[0]?.text}</span>
              <PrismicNextImage
                field={slice.primary.top_asset_section[0]?.asset}
                quality={100}
                className="h-auto max-h-[48px] w-full md:w-auto"
              />
            </div>
          )}
        </div>

        <div className="flex flex-col gap-8 md:gap-12">
          <MossPlatformLargeSection
            title={slice.primary.first_package_title}
            pills={slice.primary.first_package_pills}
            icon={slice.primary.first_package[0]?.module_icon!}
            moduleTitle={slice.primary.first_package[0]?.module_title!}
            description={slice.primary.first_package[0]?.description!}
            asset={slice.primary.first_package[0]?.asset!}
          />

          <LargePackageSection
            title={slice.primary.second_package_title}
            pills={slice.primary.second_package_pills}
            items={slice.primary.second_package}
          />

          <LargePackageSection
            title={slice.primary.third_package_title}
            pills={slice.primary.third_package_pills}
            items={slice.primary.third_package}
          />
        </div>
      </div>
      <CTASectionLarge
        images={slice.primary.cta_images}
        content={slice.primary.cta_content[0]!}
        componentIndex={componentIndex}
        pageUid={pageUid}
      />
    </div>
  </Container>
)
